export enum PlaceStatus {
  CreateError = 'CREATE_ERROR',
  CreateRequested = 'CREATE_REQUESTED',
  CreateSuccess = 'CREATE_SUCCESS',
  DeleteError = 'DELETE_ERROR',
  DeleteRequested = 'DELETE_REQUESTED',
  DeleteSuccess = 'DELETE_SUCCESS',
  LoadError = 'LOAD_ERROR',
  LoadRequested = 'LOAD_REQUESTED',
  LoadSuccess = 'LOAD_SUCCESS',
  UpdateError = 'UPDATE_ERROR',
  UpdateRequested = 'UPDATE_REQUESTED',
  UpdateSuccess = 'UPDATE_SUCCESS',
}
